// import {
//   CalendarIcon,
//   FireIcon,
//   GlobeIcon,
//   HomeIcon,
//   LightningBoltIcon,
// } from '@heroicons/react/solid'

import {
  IconCalendar,
  IconProducts,
  IconFlash,
  IconScooter,
  IconShop
} from '@hubii/icons'


export enum EOrderShippingMethod {
  Pickup = 1,
  QuickCommerce = 2,
  Scheduled = 3,
  Dropoff = 4,
  Express = 5,
  Flex = 6,
}

export const deliveryMethodsLabels = {
  [EOrderShippingMethod.Pickup]: 'Retire em Loja',
  [EOrderShippingMethod.QuickCommerce]: 'Entrega Rápida',
  [EOrderShippingMethod.Scheduled]: 'Agendamento',
  [EOrderShippingMethod.Dropoff]: 'Despacho',
  [EOrderShippingMethod.Express]: 'Entrega Rápida',
  [EOrderShippingMethod.Flex]: 'Flex',
}

export const orderDeliveryShippingIcon = {
  [EOrderShippingMethod.QuickCommerce]: IconFlash,
  [EOrderShippingMethod.Scheduled]: IconCalendar,
  [EOrderShippingMethod.Pickup]: IconShop,
  [EOrderShippingMethod.Dropoff]: IconProducts,
  [EOrderShippingMethod.Express]: IconScooter,
  [EOrderShippingMethod.Flex]: IconScooter,
}